import hljs from "highlight.js/lib/core";
import bash from "highlight.js/lib/languages/bash";
import javascript from "highlight.js/lib/languages/javascript";
import json from "highlight.js/lib/languages/json";
import python from "highlight.js/lib/languages/python";
import xml from "highlight.js/lib/languages/xml";
import { TooltipProvider } from "reka-ui";
import { defineComponent } from "vue";
import AlertDialogProvider from "./components/providers/AlertDialogProvider";
import DialogProvider from "./components/providers/DialogProvider";
import SheetProvider from "./components/providers/SheetProvider";
import ToasterProvider from "./components/providers/ToasterProvider";

export const ConfigChild = defineComponent((_, { slots }) => {
  return () => slots.default?.();
});

export default defineComponent({
  name: "Config",
  setup(_, { slots }) {
    hljs.configure({
      languages: ["javascript", "bash", "python", "json", "html"],
    });
    hljs.registerLanguage("javascript", javascript);
    hljs.registerLanguage("bash", bash);
    hljs.registerLanguage("python", python);
    hljs.registerLanguage("json", json);
    hljs.registerLanguage("xml", xml);

    return () => (
      <TooltipProvider>
        <ConfigChild>{slots}</ConfigChild>
        <DialogProvider />
        <SheetProvider />
        <AlertDialogProvider />
        <ToasterProvider />
      </TooltipProvider>
    );
  },
});
